import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import StateEnum from './ProgressStateEnum';
import ProgressBarComponent from './ProgressBarComponent';

const ProgressBarsWrapper = styled.div`
    display: flex;
    padding: 5px 15px;
    margin: 0px -5px;
    & > * {
        padding: 0px 5px;
        &:last-child {
            padding: 0px 5px;
        }
    }
`;

const ProgressBarWrapper = styled.div`
    flex-basis: 0px;
    flex-grow: 1;
`;

interface ProgressBarsProps
{
    currentState: StateEnum;
    visibleStates: StateEnum[];
    isCurrentStateFailed: boolean;
};

const ProgressBarsComponent = ({currentState, visibleStates, isCurrentStateFailed}: ProgressBarsProps) => {
    const [t] = useTranslation();

    const states = [
        {State: StateEnum.OnRoute, Label: t('package_progress_on_route')},
        {State: StateEnum.PickedUp, Label: t('package_progress_picked_up')},
        {State: StateEnum.InTransit, Label: t('package_progress_in_transit')},
        {State: StateEnum.OutForDelivery, Label: t('package_progress_out_for_delivery')},
        {State: StateEnum.Delivered, Label: t('package_progress_delivered')},
    ]

    return(
        <>
            <ProgressBarsWrapper>
                {states.map(s => {
                    // Only show visible states
                    if(!visibleStates.some(v => v === s.State))
                        return(null);
                    
                    return(
                        <ProgressBarWrapper key={s.State}>
                            <ProgressBarComponent 
                                label={s.Label}
                                isCurrent={s.State === currentState}
                                isComplete={s.State < currentState}
                                isError={s.State === currentState && isCurrentStateFailed}
                            />
                        </ProgressBarWrapper>
                    );
                })}
            </ProgressBarsWrapper>
        </>
    );
};

export default ProgressBarsComponent;